import { useEffect } from 'react'
import { useVirtualsMobile } from 'sb-virtuals'

const useSession = (name = "X-ODDS-SESSION") => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=")

    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, "")
}

const options = {
  showBetButton: false,
  persistSelections: false,
  topHeaderHeight: 56,
  bottomFooterHeight: 56,
}

const Virtuals = () => {
  const session = useSession()

  const [selected, deselected] = useVirtualsMobile({
    container: "#vsm_app_container",
    session,
    options,
  })

  useEffect(() => {
    selected && selected[0] && selected.map(outcome => outcome?.outcomeId && !app.service.BetSlip.betSlipData.itemsOrder.includes(outcome.outcomeId) && app.service.BetSlip.addBet({sportId: outcome.categoryLvl1Id, ...outcome}));
  }, [selected, app.service.BetSlip.betSlipData.itemsOrder])

  useEffect(() => {
    deselected && deselected[0] && deselected?.map(({ outcomeId }) => app.service.BetSlip.removeOutcome(outcomeId))
  }, [deselected])

  return null
}

export default Virtuals